import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	NgbToastModule,
	NgbProgressbarModule,
	NgbDropdownModule,
	NgbNavModule,
	NgbRatingModule,
	NgbTooltipModule,
	NgbAccordionModule,
} from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { NgbDate, NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CampaignsComponent } from './campaigns/campaigns.component';
import { SearchComponent } from './search/search.component';
import { DbresetComponent } from './dbreset/dbreset.component';
import { DisposComponent } from './dispos/dispos.component';
// Load Icons
import { defineLordIconElement } from 'lord-icon-element';
import lottie from 'lottie-web';
import { ViewsRoutingModule } from './views-routing.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { share } from 'rxjs-compat/operator/share';
import { SharedModule } from '../shared/shared.module';
import { CallbackComponent } from './caller_flow/callback/callback.component';
import { AppointmentFormComponent } from './caller_flow/appointment-form/appointment-form.component';
import { ProspectInfoComponent } from './caller_flow/prospect-info/prospect-info.component';
import { ChooseDispoComponent } from './caller_flow/choose-dispo/choose-dispo.component';
import { CalendarComponent } from '../shared/calendar/calendar.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyProductionService } from '../services/my-production/my-production.service';
import { My_productionComponent } from './my_production/my_production.component';
import { ReschedulesComponent } from './reschedules/reschedules.component';
import { LeadComponent } from './lead/lead.component';
import { PhonePipe } from '../core/pipe/phone.pipe';
import { nullToDashPipe } from '../core/pipe/nullToDash.pipe';

@NgModule({
	declarations: [
		CampaignsComponent,
		SearchComponent,
		DbresetComponent,
		DisposComponent,
		CallbackComponent,
		AppointmentFormComponent,
		ProspectInfoComponent,
		ChooseDispoComponent,
		CalendarComponent,
		My_productionComponent,
		ReschedulesComponent,
		LeadComponent,
		PhonePipe,
		nullToDashPipe,
	],
	imports: [
		ViewsRoutingModule,
		CommonModule,
		FormsModule,
		NgbToastModule,
		ReactiveFormsModule,
		NgbProgressbarModule,
		NgbDropdownModule,
		NgbNavModule,
		NgbRatingModule,
		NgbTooltipModule,
		HttpClientModule,
		NgbModule,
		NgxDatatableModule,
		SharedModule,
		FullCalendarModule,
		NgSelectModule,
	],
	exports: [],
	providers: [
		DecimalPipe
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ViewsModule {
	constructor() {
		defineLordIconElement(lottie.loadAnimation);
	}
}
